export const CLASSES_API_ROUTES = {
   DETAILS: 'testPage',
   SUBJECT_TEST_LIST :'subjectTestList',
   BOARD_FILTER_LIST :'boardFilterList'
}